<template>
  <multiselect 
    class="new-style" 
    style="min-width: 200px;" 
    v-bind="$attrs" 
    v-on="$listeners" 
    :value="localValue"
    @input="updateValue"
  >
    <template #option="props">
      <span class="option__title" v-if="props.option?.$isLabel">
        {{ props.option.$groupLabel.name }}
        <span class="label-info label-info--deselected">{{
          $t('views.seller.integrations.config.save.product.select_all') }}</span>
        <span class="label-info label-info--selected">{{
          $t('views.seller.integrations.config.save.product.remove_all') }}

        </span>
        {{ props.option.name }}
      </span>
      <span class="d-flex option__item" v-else>
        <img :src="isOptionSelected(props.option.id)" />
      </span>
    </template>

    <template #placeholder>
      <span class="select-title">Status</span>
    </template>
    <span slot="noOptions">{{ $t('views.seller.integrations.config.save.product.no_items') }}</span>
    <span slot="noResult">{{ $t('views.seller.integrations.config.save.product.no_content') }}</span>
    <div slot="limit" class="multiselect__tag limit">+{{ value?.length - 2 }}</div>
    <template #caret>
      <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
    </template>
  </multiselect>

</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'BaseSelect',
  components: { Multiselect },
  value: [String, Array, Object],
  props: {
    value: [String, Array, Object],
    inputLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value.length ? value : []);
      },
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    handleMultiselectInput(value) {
      this.value = value;
    },
    handleApplyFilter() {
      this.$emit('apply-filter', this.value);
    },
    handleRemoveFilter() {
      this.$emit('remove-filter', this.value);
    },
    isOptionSelected(id) {
      return this.value.some(item => item.id === id)
        ? require('@/assets/img/icons/checkbox-area-selected.svg')
        : require('@/assets/img/icons/checkbox-area.svg');
    }
  }
}
</script>